import * as React from "react";
import styled from "styled-components";
import { NewsletterSubscription } from "./NewsletterSubscription";
import { ContactInfo } from "./ContactInfo";
import footer from "../../assets/images/footer.png";
import theme from "../../theme";
const footerLinks = ["Home", "About Us", "Categories", "Contact Us", "Privacy Policy"];
const currentYear = new Date().getFullYear();

export default function Footer() {
  return (
    <main className="layout">
      <NewsletterSubscription />
      <ContactInfo />
      <FooterContainer>
        <Copyright>&copy; {currentYear} Mandalay HW</Copyright>
        <PoweredBy>
          Powered By{" "}
          <PoweredLink href="https://www.nksoftwarehouse.com" target="_blank" rel="noopener noreferrer">
            NK Software House
          </PoweredLink>{" "}
          - Visit us on{" "}
          <PoweredLink href="https://facebook.com/nksoftwareshouse" target="_blank" rel="noopener noreferrer">
            Facebook
          </PoweredLink>
        </PoweredBy>
      <FooterNav>
          {footerLinks.map((link, index) => (
            <React.Fragment key={link}>
              <FooterLink href={`/${link.toLowerCase().replace(/\s+/g, "")}`}>
                {link}
              </FooterLink>
              {index < footerLinks.length - 1 && <Divider />}
            </React.Fragment>
          ))}
      </FooterNav>
    </FooterContainer>
    {/* <Wave src={footer} alt="footer" /> */}
  </main>
  );
}

const Wave = styled.img`
  width: 100%;
  height: clamp(4rem, 9vw, 7rem);
  object-fit: cover;
  object-position: center;
  display: block;
`;

const FooterContainer = styled.footer`
  margin-top: 32px;
  margin-bottom: 16px;
  text-align: center;
`;

const Copyright = styled.p`
  font: 400 12px Amiko, sans-serif;
  margin: 16px 0 8px;
`;

const PoweredBy = styled.p`
  font: 400 12px Amiko, sans-serif;
  color: ${theme.palette.grey.main};
  margin-bottom: 16px;
`;

const PoweredLink = styled.a`
  color: #007bff; /* Use a distinct color for links */
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const FooterNav = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  font: 400 12px Anek Gurmukhi, sans-serif;
  margin-bottom: 0;
`;

const FooterLink = styled.a`
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: underline;
  }
`;

const Divider = styled.span`
  width: 1px;
  height: 20px;
  background: #000;
`;
